import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Version = ({ collapsed }: { collapsed: boolean }) => {

  const themeQuery = useTheme();
  const isMobile = useMediaQuery(themeQuery.breakpoints.down("lg"));

  return (
    <>
      <Box
        sx={{
          padding: '10px',
          mb: '10px',
        }}
      >
        <Stack
          alignItems={'center'}
          sx={{
            background: 'linear-gradient(343deg, #ffffff1c, #ffffff30)',
            flexDirection: 'column',
            borderRadius: '10px',
            textAlign: 'center',
            p: '5px',
          }}
        >
          <img
            src="https://www.stagemporium.com/wp-content/themes/stagsemporium/images/logo.png"
            alt=""
            className={`w-[${isMobile?'20px':'35px'}] h-[${isMobile?'20px':'35px'}] object-contain`}
          />
          <Typography
            mt={'5px'}
            variant={'caption'}
          >
            Zoe App
          </Typography>
          <Typography
            variant={'caption'}
            color={'#dfdfdf'}
          >
            Version:{' '}
            {collapsed && (
              <>
                <br />
              </>
            )}{' '}
            1.0.0
          </Typography>
        </Stack>
      </Box>
    </>
  );
};
export default Version;
